import { render, staticRenderFns } from "./people_level.vue?vue&type=template&id=78d6929e&scoped=true"
import script from "./people_level.vue?vue&type=script&lang=js"
export * from "./people_level.vue?vue&type=script&lang=js"
import style0 from "./people_level.vue?vue&type=style&index=0&id=78d6929e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d6929e",
  null
  
)

export default component.exports